import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { login } from '../utils/api';
import { useAuth } from '../context/AuthContext';
import { toast } from 'sonner';

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { login: authLogin } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const data = await login(email, password);
      authLogin(data.token, data.role);
      toast.success('¡Bienvenido!');
      
      if (data.role === 'admin') {
        navigate('/admin');
      } else {
        navigate('/client');
      }
    } catch (error) {
      toast.error('Credenciales inválidas. Por favor, inténtalo de nuevo.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen pharmacy-gradient flex items-center justify-center p-4">
      <Card className="w-full max-w-md pharmacy-card" data-testid="login-card">
        <CardHeader className="text-center space-y-4">
          <div className="flex justify-center">
            <img 
              src="/logo.jpg" 
              alt="Farmacia Tarin" 
              className="h-32 w-auto object-contain"
              data-testid="pharmacy-logo"
            />
          </div>
          <CardTitle className="text-3xl font-bold text-green-800">
            Farmacia Tarin
          </CardTitle>
          <CardDescription className="text-lg">
            Seguimiento Dieta Siken
          </CardDescription>
          <div className="flex justify-center items-center gap-4 mt-4 flex-wrap">
            <img src="/siken.jpg" alt="Siken" className="h-12 object-contain" />
            <img src="/fortepharma.jpg" alt="Fortepharma" className="h-12 object-contain" />
            <img src="/therascience.jpg" alt="Therascience" className="h-12 object-contain" />
          </div>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-4" data-testid="login-form">
            <div className="space-y-2">
              <Label htmlFor="email">Email o Usuario</Label>
              <Input
                id="email"
                type="text"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Tu email"
                required
                className="pharmacy-input"
                data-testid="email-input"
              />
            </div>
            <div className="space-y-2">
              <Label htmlFor="password">Contraseña</Label>
              <Input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Tu contraseña"
                required
                className="pharmacy-input"
                data-testid="password-input"
              />
            </div>
            <Button
              type="submit"
              className="w-full pharmacy-button text-white font-semibold py-6 rounded-full"
              disabled={loading}
              data-testid="login-button"
            >
              {loading ? 'Accediendo...' : 'Acceder'}
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
};

export default LoginPage;